import { combineReducers } from 'redux';

import fetchStandards from './fetchStandards';

export default combineReducers({
  fetchStandards,
});
